import { Component, computed, input } from '@angular/core';
import { Severity } from '../../../../../core/enums';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'dbx-speedometer',
  templateUrl: './speedometer.component.html',
  styleUrl: './speedometer.component.scss',
  standalone: true,
  imports: [TranslatePipe],
})
export class SpeedometerComponent {
  severity = input<Severity | undefined>();
  size = input<'' | 'small'>('');

  lowSpeed = computed(() => Math.round((Math.min(this.severity() ?? 0, 25) * 180) / 100) - 45);
  mediumSpeed = computed(() => Math.round((Math.min(this.severity() ?? 0, 60) * 180) / 100) - 45);
  highSpeed = computed(() => Math.round((Math.min(this.severity() ?? 0, 85) * 180) / 100) - 45);
  criticalSpeed = computed(() => Math.round(((this.severity() ?? 0) * 180) / 100) - 45);
  needleSpeed = computed(() => Math.round(((this.severity() ?? 0) * 180) / 100) - 90);

  readonly Severity = Severity;
}
